import {StockMovementEditor} from "./CreateOpeningStock.jsx";
export default function AdjustStocks(props){return <StockMovementEditor {...props} kind="adjustment"/>;}
